/*
  Trunk Show 2026 (SBFA) - prev/next arrows over the main product image.

  Dawn ships slider arrows only for the mobile media slider and hides them
  from 990px up, so desktop had no click-through control at all. These
  buttons drive the theme's own <media-gallery> element through
  setActiveMedia(), so thumbnails, the accessibility live region and video
  pausing all stay in sync with stock behaviour.

  Removing this file and its <script> in sections/main-product.liquid
  restores stock Dawn.
*/
(function () {
  function buildButton(direction, label) {
    var button = document.createElement('button');
    var path = direction === 'prev' ? 'M15 5 L8 12 L15 19' : 'M9 5 L16 12 L9 19';
    button.type = 'button';
    button.className = 'custom-gallery-arrow custom-gallery-arrow--' + direction;
    button.setAttribute('aria-label', label);
    button.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' + path + '" fill="none" stroke="currentColor" stroke-width="2.2"' +
      ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return button;
  }

  function init(gallery) {
    if (gallery.dataset.customArrows === 'true') return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var list = viewer.querySelector('.product__media-list');
    if (!list) return;
    if (slides().length < 2) return;

    gallery.dataset.customArrows = 'true';

    // Only the <li> slides. The zoom toggle button inside each slide also
    // carries a data-media-id (the bare media id), so an unscoped
    // [data-media-id] query returns twice as many nodes as there are images.
    function slides() {
      var found = list.querySelectorAll(':scope > li[data-media-id]');
      if (!found.length) found = list.querySelectorAll('.product__media-item[data-media-id]');
      return Array.prototype.slice.call(found);
    }

    function currentIndex(items) {
      // On mobile the list is a real horizontal slider, so trust scroll
      // position; swiping does not update is-active in stock Dawn.
      if (list.scrollWidth > list.clientWidth + 4) {
        var best = 0;
        var bestDistance = Infinity;
        items.forEach(function (el, i) {
          var distance = Math.abs(el.offsetLeft - list.scrollLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        return best;
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function step(delta) {
      var items = slides();
      if (!items.length) return;
      var next = (currentIndex(items) + delta + items.length) % items.length;
      var target = items[next];
      var mediaId = target.dataset.mediaId;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
        return;
      }
      // Fallback if the custom element has not upgraded yet.
      items.forEach(function (el) {
        el.classList.remove('is-active');
      });
      target.classList.add('is-active');
      list.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    var previous = buildButton('prev', 'Previous image');
    var next = buildButton('next', 'Next image');
    previous.addEventListener('click', function (event) {
      event.preventDefault();
      step(-1);
    });
    next.addEventListener('click', function (event) {
      event.preventDefault();
      step(1);
    });

    viewer.classList.add('custom-gallery-arrows-host');
    viewer.appendChild(previous);
    viewer.appendChild(next);
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
